import {Logger} from '#core/utils/logger.js';

export const apiLog = Logger(`${PRODUCT_NAME}  API`);

export function wrapExternal(fn) {
    if (!fn) return fn;

    return (...params) => {
        try {
            return fn(...params);
        } catch (e) {
            apiLog.warn(`Failed to call external method: ${e.message}`);
        }
    };
}
